import React from 'react';
import { Field } from 'redux-form';
import _ from 'lodash';

import { DailyDepositFieldEnum as Fields } from 'Common/FieldEnum';
import { formatDecimal } from 'Common/FormHelper';
import { InputField } from 'Common/SemanticWrapper';

export const DenominationFields = [
  Fields.C1,
  Fields.C5,
  Fields.C10,
  Fields.C25,
  Fields.C50,
  Fields.D1,
  Fields.D5,
  Fields.D10,
  Fields.D20,
  Fields.D50,
  Fields.D100,
];

export const extractDenominations = values => {
  const denominations = _.pick(values, DenominationFields);

  DenominationFields.forEach(key => {
    if (!denominations[key]) {
      denominations[key] = 0;
    }
  });
  return denominations;
};

export const SubmitActionEnum = {
  Save: 'Save',
  CloseDay: 'CloseDay',
  ViewDailyDeposit: 'ViewDailyDeposit',
  ViewBankDeposit: 'ViewBankDeposit',
};

export const SiteFieldEnum = {
  SiteId: 'SiteId',
  AttendanceFactor: 'AttendanceFactor',
  Attendance: 'ADA',
  Membership: 'ADM',
  MaxFree: 'MaxFree',
  AllowedFree: 'AllowedFree',
  MaxReduced: 'MaxRed',
  AllowedReduced: 'AllowedReduced',
  MaxPaid: 'MaxPaid',
  AllowedPaid: 'AllowedPaid',
};

export const MealTypeOptions = [
  {
    text: 'Breakfast/Lunch/Other',
    value: false,
  },
  {
    text: 'Supper',
    value: true,
  },
];

export const SiteColumns = (onAttendanceBlur, disabled) => [
  { Header: 'Site', accessor: SiteFieldEnum.SiteId },
  {
    Header: (
      <span>
        Attendance
        <br />
        Factor
      </span>
    ),
    Cell: row => (
      <Field
        label={false}
        compact
        component={InputField}
        name={`${Fields.Sites}[${row.index}].${SiteFieldEnum.AttendanceFactor}`}
        formatOnBlur={formatDecimal(2)}
        handleBlur={onAttendanceBlur(true, row.index)}
        maxLength={6}
        disabled={disabled}
      />
    ),
  },
  {
    Header: 'Attendance',
    Cell: row => (
      <Field
        label={false}
        compact
        component={InputField}
        name={`${Fields.Sites}[${row.index}].${SiteFieldEnum.Attendance}`}
        handleBlur={onAttendanceBlur(false, row.index)}
        maxLength={6}
        disabled={disabled}
      />
    ),
  },
  { Header: 'Membership', accessor: SiteFieldEnum.Membership },
  {
    Header: (
      <span>
        Max
        <br />
        Free
      </span>
    ),
    width: 70,
    accessor: SiteFieldEnum.MaxFree,
  },
  {
    Header: (
      <span>
        Allowed
        <br />
        Free
      </span>
    ),
    width: 70,
    accessor: SiteFieldEnum.AllowedFree,
  },
  {
    Header: (
      <span>
        Max
        <br />
        Reduced
      </span>
    ),
    width: 70,
    accessor: SiteFieldEnum.MaxReduced,
  },
  {
    Header: (
      <span>
        Allowed
        <br />
        Reduced
      </span>
    ),
    width: 70,
    accessor: SiteFieldEnum.AllowedReduced,
  },
  {
    Header: (
      <span>
        Max
        <br />
        Paid
      </span>
    ),
    width: 70,
    accessor: SiteFieldEnum.MaxPaid,
  },
  {
    Header: (
      <span>
        Allowed
        <br />
        Paid
      </span>
    ),
    width: 70,
    accessor: SiteFieldEnum.AllowedPaid,
  },
];

export const MealSummaryFieldEnum = {
  UserName: 'UserName',
  TypeOfSummary: 'TypeOfSummary',
  OpenAmount: 'OpenAmount',
  CloseAmount: 'CloseAmount',
};

export const MealSummaryColumns = [
  { Header: 'User', accessor: MealSummaryFieldEnum.UserName },
  { Header: 'Meal', accessor: MealSummaryFieldEnum.TypeOfSummary },
  {
    Header: 'Open',
    id: 'Open',
    accessor: row => formatDecimal(2)(row[MealSummaryFieldEnum.OpenAmount]),
  },
  {
    Header: 'Close',
    id: 'Close',
    accessor: row => formatDecimal(2)(row[MealSummaryFieldEnum.CloseAmount]),
  },
  {
    Header: 'Net $',
    id: 'Net',
    accessor: row =>
      formatDecimal(2)(
        row[MealSummaryFieldEnum.CloseAmount] -
          row[MealSummaryFieldEnum.OpenAmount]
      ),
  },
];



// WEBPACK FOOTER //
// ./src/pages/dailydeposit/helpers/DailyDepositHelpers.js